import PageHero from "@/components/shared/PageHero";
import FrameworkTimeline from "@/components/sections/FrameworkTimeline";
import {
  JourneyFlowsSection,
  WealthHeadlineSection,
  KeyInsightsSection,
  PromisesSection,
} from "@/components/sections/FrameworkExtras";
import CTASection from "@/components/sections/CTASection";
import { ASSETS, BRAND } from "@/lib/brand";

export default function FrameworkPage() {
  return (
    <div data-testid="page-framework">
      <PageHero
        eyebrow="The W.A.T.E.R Framework"
        title={
          <>
            Build wealth <span className="italic text-bronze">deliberately</span> — not by accident.
          </>
        }
        sub={
          "Your home isn't just where you live — it's how you build the life you want. " +
          "A strategic framework for Singapore homeowners who want to stop sitting on equity and start building real wealth."
        }
        image={ASSETS.lifestyle.handshake}
        ctas={[
          { label: "Start Your W.A.T.E.R Journey", href: BRAND.whatsapp, variant: "primary" },
          { label: "Get Valuation", href: BRAND.valuationLink, variant: "secondary" },
        ]}
        stats={[
          { k: "5", v: "Stages, one path" },
          { k: "80/20", v: "Decisions that matter" },
          { k: "20+ yrs", v: "Wealth horizon" },
        ]}
      />

      <FrameworkTimeline />
      <WealthHeadlineSection />
      <JourneyFlowsSection />
      <KeyInsightsSection />
      <PromisesSection />
      <CTASection />
    </div>
  );
}
